import PropTypes from 'prop-types';
import { Icon } from '../common/Icons';
import {
  StyledContainer,
  StyledImageContainer,
  StyledItemCountContainer,
  StyledTitle,
  StyledBoardOptions,
  StyledLink,
} from './BoardItem.styles';

function BoardItem({ data }) {
  if (!Object.entries(data).length) return null;

  return (
    <StyledContainer>
      {data.image && (
        <StyledImageContainer>
          <img src={data.image} alt={data.alt} />
        </StyledImageContainer>
      )}
      {data.itemCount && <StyledItemCountContainer>{data.itemCount}</StyledItemCountContainer>}

      {data.title && (
        <StyledTitle>
          <StyledLink to={data.link || './'}>{data.title}</StyledLink>
          <StyledBoardOptions>
            <Icon.Options aria-hidden />
          </StyledBoardOptions>
        </StyledTitle>
      )}
    </StyledContainer>
  );
}

BoardItem.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.string,
    itemCount: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
  }),
};

BoardItem.defaultProps = {
  data: {},
};

export default BoardItem;
